<template>
	<div class="favorites-container">
		<div v-if="loading" class="loading-state">加载中...</div>
		<EmptyState v-else-if="favorites.length === 0" description="暂无收藏内容" />
		<div v-else class="course-grid">
			<div class="course-card" v-for="course in favorites" :key="course.id" @click="goToDetail(course)">
				<div class="cover-wrapper">
					<img :src="course.image" :alt="course.title" class="course-cover" />
					<span class="badge" v-if="course.badge">{{ course.badge }}</span>
				</div>
				<div class="course-info">
					<h3 class="course-title">{{ course.title }}</h3>
					<div class="course-meta">
						<span class="views">{{ course.views }}人浏览</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getFavorites
	} from '@/api/user'
	import EmptyState from '@/components/EmptyState.vue'

	export default {
		name: 'MyFavorites',
		components: {
			EmptyState
		},
		data() {
			return {
				favorites: [],
				loading: false
			}
		},
		mounted() {
			this.fetchFavorites()
		},
		methods: {
			goToDetail(course) {
				if (course && (course.id || course.courseId)) {
					this.$router.push({
						name: 'CourseDetail',
						params: {
							id: course.id || course.courseId
						}
					})
				}
			},
			async fetchFavorites() {
				this.loading = true
				try {
					const res = await getFavorites()
					if (res.code === 200) {
						this.favorites = (res.rows || []).map(item => {
							let badgeText = ''
							const vType = Number(item.course.viewType)
							switch (vType) {
								case 1:
									badgeText = '免费'
									break
								case 2:
									badgeText = 'VIP'
									break
								case 3:
									badgeText = '付费'
									break
								default:
									badgeText = item.badge
							}
							return {
								id: item.courseId,
								title: item.course.title,
								image: item.course.coverImg,
								badge: badgeText,
								views: item.course.sales
							}
						})
					}
				} catch (error) {
					console.error('获取收藏列表失败:', error)
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.favorites-container {
		width: 100%;
	}

	.loading-state {
		text-align: center;
		padding: 40px;
		color: #999;
		font-size: 14px;
	}

	.course-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;

		.course-card {
			background-color: transparent;
			border-radius: 8px;
			overflow: hidden;
			cursor: pointer;
			transition: transform 0.3s;

			&:hover {
				transform: translateY(-5px);
			}

			.cover-wrapper {
				position: relative;
				width: 100%;
				height: 170px;
				border-radius: 6px;
				overflow: hidden;
				margin-bottom: 10px;

				.course-cover {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.badge {
					position: absolute;
					top: 0;
					right: 0;
					background: linear-gradient(90deg, #FFC972 0%, #FFA73B 100%);
					color: #522606;
					font-size: 12px;
					padding: 2px 8px;
					border-bottom-left-radius: 6px;
					font-weight: bold;
				}
			}

			.course-info {
				.course-title {
					color: #fff;
					font-size: 14px;
					line-height: 1.4;
					margin-bottom: 8px;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
					font-weight: normal;
				}

				.course-meta {
					.views {
						color: #666;
						font-size: 12px;
					}
				}
			}
		}
	}
</style>